export function getPushServerKey() {
	// TODO: Заменить ключом для бриксов, когда он появится
	if (import.meta.env.VITE_APP_TENANT_OVERRIDE === "RBW")
		return "BE6hvbE5n5KekFrxsQEeAP3SincM7MGN-1Wy4K_NCRo3JDdIORr6cPqKbLKLVvFNk5HKOzwKe503zu94LtYIXB4";
	return "BE6hvbE5n5KekFrxsQEeAP3SincM7MGN-1Wy4K_NCRo3JDdIORr6cPqKbLKLVvFNk5HKOzwKe503zu94LtYIXB4";
}
